/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M11.2 12.8V3.2h-.8a10.5526 10.5526 0 0 0-1.2.0685C4.0215 3.8635 0 8.262 0 13.6 0 19.3438 4.6562 24 10.4 24c5.3379 0 9.7366-4.0215 10.3315-9.2a10.5379 10.5379 0 0 0 .0685-1.2v-.8h-9.6Zm12.7768-3.1c.0154.2313.0232.4648.0232.7v.8H12.8V0h.8a10.5548 10.5548 0 0 1 1.2.0685c4.7848.5497 8.5818 4.3467 9.1315 9.1315.019.1655.0342.3322.0453.5ZM14.3 1.527c.1102.0086.2198.0192.3288.0317 4.092.4701 7.3424 3.7205 7.8125 7.8125.0125.109.0231.2186.0317.3288H14.3V1.527Z"
    clipRule="evenodd"
  />,
  'MenuOperationalAnalyticsFilled'
);
